import { getReferralsRewards } from "@utils/call-api/referral-call";

export const TYPES = {
  SET_REFERRAL_REWARDS: "SET_REFERRAL_REWARDS",
};

function setReferralRewards(referralRewards) {
  return {
    type: TYPES.SET_REFERRAL_REWARDS,
    referralRewards,
  };
}

export async function getReferralsRewardsAction(dispatch) {
  const referralRewards = await getReferralsRewards();
  dispatch(setReferralRewards(referralRewards));
}

export function reloadReferralsRewardsAction() {
  return async (dispatch) => {
    const referralRewards = await getReferralsRewards();
    dispatch(setReferralRewards(referralRewards));
  };
}
